import { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useTitle } from 'react-use';
import { useDispatch, connect } from 'react-redux';

import { ICheckesDataResponse } from 'ApiPackage/OpenDataModule/interfaces/ICheckesDataResponse';
import { Layout } from 'CorePackage/MainModule/components/Layout';
import { ROUTE_OPEN_DATA } from 'CorePackage/MainModule/constants/routes';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { PassportComponent } from './PassportComponent';
import { DownloadComponent } from './DownloadComponent';
import styles from './OpenDataShared.module.scss';
import { publicOpenDataGetChecksData } from '../actions/publicOpenDataActions';
import { getPublicOpenDataChecksData } from '../reducers/publicOpenDataReducer';

interface IChecksDataStoreProps {
  checksData?: ICheckesDataResponse;
}

const ChecksDataWithoutStore = ({ checksData }: IChecksDataStoreProps) => {
  useTitle('Паспорт открытых данных');
  const dispatch = useDispatch();
  const { year, month } = useParams<{ year: string; month: string }>();
  const { search } = useLocation();
  const isFederalLaw = new URLSearchParams(search).get('isFederalLaw248') === 'true';
  const [activeTab, setActiveTab] = useState(false);

  useEffect(() => {
    window.scroll(0, 0);
    dispatch(publicOpenDataGetChecksData(Number(year), month, isFederalLaw));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      {checksData && (
        <div className="shared-content">
          <div className={styles.TitleWrap}>
            <Link to={ROUTE_OPEN_DATA} className={styles.BackBtn} />
            <h2 className={styles.TitleH1}>{checksData.datasetPassport?.datasetName}</h2>
          </div>
          <ul className={styles.Tabs}>
            <li className={!activeTab ? styles.Active : ''}>
              <span onClick={() => setActiveTab(false)}>Паспорт</span>
            </li>
            <li className={activeTab ? styles.Active : ''}>
              <span onClick={() => setActiveTab(true)}>Скачать</span>
            </li>
          </ul>
          {activeTab ? <DownloadComponent data={checksData} /> : <PassportComponent data={checksData} />}
        </div>
      )}
    </Layout>
  );
};

const mapStateToProps = (state: IRootState): IChecksDataStoreProps => ({
  checksData: getPublicOpenDataChecksData(state),
});

export const ChecksData = connect(mapStateToProps)(ChecksDataWithoutStore);
